import React from 'react';
import { useSelector } from 'react-redux';
import { Menu as PrimeMenu } from "primereact/menu";

import { checkPermissions } from '../utils';
import PermDetailsWrapper from '../common/PermDetailsWrapper';
 

function Menu(props) {
    const userDetails = useSelector(state => state.userDetails)

    let className = props.className ? props.className : ""
    let menuItems = props.model

    const permParams = {
        activeCompanyRoleId: userDetails.activeCompanyRoleId,
        userRoleId: userDetails.activeRoleId,
        permExceptions: userDetails.permExceptions,
        permGeo: userDetails.permGeo,
        permActions: userDetails.permActions,
        permRoles: userDetails.permRoles
    }

    menuItems = menuItems.map(eachItem => {
        if(eachItem.permissions?.length){
            const { isPermitted, permittedCompanyRoleIds, permittedExceptionUserRoleIds, permittedExceptionNegitiveUserRoleIds } = checkPermissions({...permParams, reqPermActionIds: eachItem.permissions})
            const isDisabled = eachItem.disabled

            eachItem.disabled = eachItem.disabled || !isPermitted ? true : false

            eachItem.label = 
                <div uniqueId={eachItem.label} className={eachItem.disabled ? "custom-disabled-item" : ""}>
                    <PermDetailsWrapper
                        displayComponent={<span className="hover-wrapper">{eachItem.label}</span>}
                        uniqueId={eachItem.label}
                        permissions={eachItem.permissions}
                        permittedCompanyRoleIds={permittedCompanyRoleIds}
                        permittedExceptionUserRoleIds={permittedExceptionUserRoleIds}
                        permittedExceptionNegitiveUserRoleIds={permittedExceptionNegitiveUserRoleIds}
                        visible={!isDisabled && !isPermitted}
                    />
                </div>
        }
        return eachItem
    })

    return (
        <PrimeMenu model={menuItems} popup ref={props.menuRef} />
    )
}

export default Menu;